// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"a0b1f558","111":"a9c794d2","181":"bfe98265","453":"cc295339","530":"4e22eab0","576":"87d68e8c"}[chunkId] + ".chunk.js";
};